<template>
  <div class="stepper-component">
    <v-navigation-drawer
      right
      mini-variant-width="80"
      app
      :width="asideWidth"
      class="navigation"
      height="100vh"
    >
      <v-loader v-if="isLoading || checkingBasketItemsChanges" absolute />

      <div
        v-if="showPersonError"
        class="person-error d-flex align-center justify-center"
      >
        <div
          class="error-window d-flex flex-column align-center justify-center"
        >
          <span class="error-window-title">Внимание</span>
          <span class="error-window-text">Вы не указали количество персон</span>
          <v-btn
            class="error-window-button"
            x-large
            dark
            depressed
            @click="showPersonError = false"
          >
            Ок
          </v-btn>
        </div>
      </div>

      <div class="stepper-content d-flex flex-column justify-space-between">
        <div class="stepper-header">
          <step-indicator
            :step="currentStep"
            available-all-steps
            @change-step="changeStepByTab"
          />

          <div class="button-group-section d-flex align-center j-between">
            <span class="label font-weight-medium">Ваш заказ:</span>
            <div class="buttons d-flex align-center">
              <v-btn-toggle v-model="otherWindow" dense group>
                <v-btn
                  value="modifications"
                  class="button-param button-toggle font-weight-medium"
                  depressed
                  color="#F1F3F6"
                >
                  М
                </v-btn>
                <v-btn
                  value="commentaries"
                  class="button-param button-toggle font-weight-medium"
                  depressed
                  color="#F1F3F6"
                >
                  <font-awesome-icon icon="comment-dots" />
                </v-btn>
                <v-btn
                  value="preorder"
                  class="button-param button-toggle font-weight-medium"
                  :class="{'v-item--active': hasPreorder}"
                  :disabled="!basket.filialId"
                  depressed
                  color="#F1F3F6"
                >
                  <font-awesome-icon icon="clock" />
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </div>

        <div class="order-list-section">
          <div
            v-if="!normalBasketItems && !modBasketItems"
            class="empty-section d-flex align-center justify-center flex-column"
          >
            <font-awesome-icon icon="shopping-bag" color="#DDE1E6" />
            <span>Не добавлено...</span>
          </div>
          <perfect-scrollbar :options="{ suppressScrollX: true }">
            <div class="order-list-content">
              <div
                v-if="normalBasketItems || modBasketItems"
                class="food-counter"
              >
                <food-counter
                  v-for="item in normalBasketItems"
                  :key="item.hash"
                  :item="item"
                />
                <food-counter
                  v-for="modItem in modBasketItems"
                  :key="modItem.id"
                  :item="modItem"
                />
                <food-counter
                  v-for="commentItem in commentBasketItems"
                  :key="commentItem.id"
                  :item="commentItem"
                />
              </div>
            </div>
          </perfect-scrollbar>
        </div>

        <div class="stepper-footer">
          <v-delivery v-if="showDelivery" :price="basket.deliveryPrice" />

          <div class="order-info-section">
            <v-row class="order-details">
              <v-col>
                <person-count />
              </v-col>
              <v-col>
                <div class="payment-method">
                  <span class="label">Тип оплаты</span>
                  <span class="method-title font-weight-bold">{{
                    getPaymentType
                  }}</span>
                </div>
                <promocode-short :promocode="basket.promoCode" />
              </v-col>
              <v-col>
                <div class="payment-amount">
                  <span class="label">Итого к оплате</span>
                  <span class="amount font-weight-medium">{{ getTotalPrice | amountWithCurrency }}</span>
                  <span v-if="basket.discountTotal" class="d-block">Скидка: {{ basket.discountTotal }} ₽</span>
                </div>
                <fox-coin-label />
              </v-col>
            </v-row>

            <!--            <div v-if="isNewClient" style="font-weight: bold; margin-bottom: 10px; margin-top: -5px; font-size: 13px; color: red">
              <font-awesome-icon icon="exclamation-circle" style="margin-right: 5px; font-size: 16px"/> НОВЫЙ КЛИЕНТ
            </div>-->

            <client-source-select action="edit-order" />

            <additional-actions v-if="currentStep === 2" />

            <v-filials v-if="currentStep >= 2" />

            <delivery-pickup />

            <delivery-address
              v-if="basket.clientAddress"
              :address="basket.clientAddress"
            />

            <div class="submit-section">
              <div class="combined-submit-button d-flex a-center">
                <transition name="fadeUp" :duration="100">
                  <cooking-time v-if="showClocksWindow" @close="showClocksWindow = false" />
                </transition>
                <v-tooltip top z-index="1001" :disabled="!isTimeChangeLocked">
                  <template #activator="{ on }">
                    <v-btn
                      :disabled="!allowSetOrderTime"
                      class="button-clocks"
                      :class="{ 'button-clocks--locked': isTimeChangeLocked }"
                      color="#FB8C00"
                      dark
                      depressed
                      v-on="on"
                      @click="onClocksClick"
                    >
                      <icon-clocks />
                    </v-btn>
                  </template>
                  <span>{{ timeChangeLockedMessage }}</span>
                </v-tooltip>
                <v-btn
                  v-if="canConfirmOrder"
                  class="button-submit font-weight-medium"
                  width="100%"
                  color="#FB8C00"
                  dark
                  depressed
                  :disabled="!allowConfirmOrder"
                  @click="updateOrder"
                >
                  Подтвердить
                  <template v-if="isPreorder">
                    предзаказ
                  </template>
                  <template v-else>
                    заказ
                  </template>
                  <br>

                  <template v-if="isPreorder">
                    (Начать готовить за {{ getCookingAndDeliveryTime }})
                  </template>
                  <template v-else>
                    {{ getCookingAndDeliveryTime }}
                  </template>
                </v-btn>
                <v-btn
                  v-else
                  class="button-submit font-weight-medium"
                  width="100%"
                  color="#FB8C00"
                  dark
                  depressed
                  @click="$router.push('/orders')"
                >
                  Закрыть редактирование <br>
                  <template v-if="isPreorder">
                    (Начать готовить за {{ getCookingAndDeliveryTime }})
                  </template>

                  <template v-else>
                    {{ getCookingAndDeliveryTime }}
                  </template>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <edit-session-dialog />
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import VLoader from '@/components/loader/Loader'
  import IconClocks from '@/components/icons/IconClocks.vue'
  import FoodCounter from '../../order-components/stepper/FoodCounter.vue'
  import DrinkDetails from './DrinkDetails'
  import DeliveryAddress from '@/components/order-processing/order-components/stepper/DeliveryAddress'
  import DeliveryPickup from '@/components/order-processing/order-components/stepper/DeliveryPickup'
  import PersonCount from '@/components/order-processing/order-components/stepper/PersonCount'
  // import VPromocode from '@/components/order-processing/order-components/stepper/Promocode'
  import VDelivery from '@/components/order-processing/order-components/stepper/Delivery'
  import CookingTime from '@/components/order-processing/order-components/stepper/CookingTime'
  import VFilials from '@/components/order-processing/order-components/stepper/Filials'
  import mixinGetCookingTime from '@/mixins/get-cooking-time'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  // import FoxCoinAddLabel from '@/components/order-processing/order-components/stepper/FoxCoinAddLabel'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import FoxCoinLabel from '@/components/order-processing/order-components/stepper/FoxCoinLabel'
  import ClientSourceSelect from '@/components/order-processing/order-components/stepper/ClientSourceSelect'
  import _ from 'lodash'
  import StepIndicator from '@/components/order-processing/order-components/stepper/StepIndicator.vue'
  import EditSessionDialog from '../../order-components/EditSessionDialog.vue'
  import AdditionalActions from '@/components/order-processing/new-order/stepper/AdditionalActions.vue'

  export default {
    name: 'Stepper',
    components: {
      AdditionalActions,
      StepIndicator,
      FoxCoinLabel,
      // FoxCoinAddLabel,
      VLoader,
      FoodCounter,
      VDelivery,
      DrinkDetails,
      DeliveryAddress,
      DeliveryPickup,
      PersonCount,
      // VPromocode,
      CookingTime,
      IconClocks,
      VFilials,
      ClientSourceSelect,
      EditSessionDialog,
    },
    mixins: [mixinGetCookingTime, mixinSnackbarMessage],
    data () {
      return {
        asideWidth: 454,
        showPersonError: false,
        showClocksWindow: false,
      }
    },
    computed: {
      ...mapState({
        isDrinksSuggested: state => state.fastOrder.isDrinksSuggested,
        currentOtherWindow: state => state.fastOrder.currentOtherWindow,
        basket: state => state.baskets.basket,
        isLoading: state => state.baskets.isBasketLoading,
        currentStep: state => state.fastOrder.currentStep,
        categories: state => state.categories.categoriesList,
        orderId: state => state.fastOrder.orderId,
        currentOrder: state => state.fastOrder.currentOrder,
        currentEditOrder: state => state.orders.currentEditOrder,
        checkingBasketItemsChanges: state => state.editSession.checkingBasketItemsChanges,
      }),
      ...mapGetters({
        normalBasketItems: 'baskets/getNormalBasketItems',
        modBasketItems: 'baskets/getModifiedBasketItems',
        commentBasketItems: 'baskets/getCommentedBasketItems',
        basketItems: 'baskets/getItems',
        getTotalPrice: 'baskets/getTotalPrice',
        isSourceAggregator: 'baskets/isSourceAggregator',
        isTimeChangeLocked: 'orders/isTimeChangeLocked',
        timeChangeLockedMessage: 'orders/timeChangeLockedMessage',
      }),
      isNewClient () {
        return this.currentEditOrder &&
          this.currentEditOrder.client &&
          !this.currentEditOrder.client.firstCompletedOrderId
      },
      hasPreorder () {
        return !!this.basket.dateDelivery
      },
      canConfirmOrder () {
        if (this.currentEditOrder && this.currentEditOrder.orderStatus === 'new') {
          return true
        }
        return false
      },
      allowSetOrderTime () {
        if (this.canConfirmOrder) {
          return this.allowConfirmOrder
        }
        return true
      },
      allowConfirmOrder () {
        return /* this.isDrinksSuggested && */ !this.needSetClientSource
      },
      needSetClientSource () {
        return false
        // this.isNewClient && !this.hasClientRegistrationSource && !this.isSourceAggregator
      },
      hasClientRegistrationSource () {
        return !!this.basket?.client?.registrationMarketingSource
      },
      isBasketHaveDrinks () {
        /* const basketItems = this.basket.items || null
        const drinksCategory = this.categories.find(category => category.slug === 'drinks')
        if (basketItems && drinksCategory) {
          const drinksMenuItems = drinksCategory.menuItems.map(item => item.id)
          return !!basketItems.some(item => {
            return drinksMenuItems.includes(item.menuItemId)
          })
        } */
        return false
      },
      otherWindow: {
        get () {
          return this.currentOtherWindow
        },
        set (value) {
          this.$store.commit('fastOrder/setCurrentOtherWindow', value)
        },
      },
      showDelivery () {
        return (
          this.basket.deliveryPrice && this.basket.deliveryPrice.amount !== '0'
        )
      },
      allowSetDeliveryTime () {
        return !!this.basket.deliveryType
      },
      getPaymentType () {
        if (this.basket.paymentType) {
          return PaymentType.getName(this.basket.paymentType, this.basket.deliveryType, PaymentMode.ofOrder(this.currentEditOrder))
        }
        return '–'
      },
      isPreorder () {
        return !!this.basket.toDatetime
      },
    },
    watch: {
      isBasketHaveDrinks () {
        if (this.isBasketHaveDrinks) {
          this.$store.commit('fastOrder/setDrinkDetailsStatus', true)
        }
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.calcAsideWidth()
      })
      if (this.isBasketHaveDrinks) {
        this.$store.commit('fastOrder/setDrinkDetailsStatus', true)
      }
    },
    created () {
      window.addEventListener('resize', this.calcAsideWidthOnResize)
    },
    destroyed () {
      window.removeEventListener('resize', this.calcAsideWidthOnResize)
    },
    methods: {
      changeStepByTab (i) {
        // if (!this.isTabsBlocked) {
        this.$store.commit('fastOrder/setStep', i)
        // }
      },
      onClocksClick () {
        if (this.isTimeChangeLocked) {
          this.showWarningMessage(this.timeChangeLockedMessage)
          return
        }
        this.showClocksWindow = !this.showClocksWindow
      },
      updateOrder () {
        if (this.basket.persons === 0) {
          this.showPersonError = true
          return
        }

        if (this.currentEditOrder.orderStatus !== 'new') {
          this.showSuccessMessage('Заказ обновлен')
          this.$router.push('/orders')
          return
        }

        this.$store.commit('baskets/setBasketLoading', true)

        const id = this.orderId
        this.$store.dispatch('orders/confirmOrder', id)
          .then(res => {
            if (res.status === 200) {
              this.showSuccessMessage('Заказ обновлен')
              this.$router.push('/orders')
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          }).finally(() => {
            this.$store.commit('baskets/setBasketLoading', false)
          })
      },
      setStep (i) {
        this.$store.commit('fastOrder/setStep', i)
      },
      calcAsideWidth () {
        this.asideWidth = window.innerWidth < 1900 ? 355 : 454
      },
      calcAsideWidthOnResize: _.debounce(function () {
        this.calcAsideWidth()
      }, 100),
    },
  }
</script>

<style lang="less" scoped>
.stepper-component {
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .person-error {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(33, 33, 33, 0.46);
    z-index: 1;

    .error-window {
      width: 95%;
      padding: 3.35em 15px 1.85em 15px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

      .error-window-title {
        display: inline-block;
        margin-bottom: 3px;
        font-size: 1.78em;
        line-height: 25px;
      }

      .error-window-text {
        display: inline-block;
        margin-bottom: 2.42em;
        font-size: 1em;
        line-height: 1;
      }

      .error-window-button {
        background-color: @color-primary;
      }
    }
  }

  .button-param {
    font-size: 1.78em;
    line-height: 1;
    width: 2em;
    height: 2em;
    min-width: 2em !important;
    padding: 0 !important;
  }

  .navigation {
    padding-top: 15px;
    background-color: transparent;

    .media-xl({
      padding-top: 23px;
    });

    &:after {
      content: '';
      position: absolute;
      display: none;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(#fafafa, 0.8);
    }

    &.disabled:after {
      display: block;
    }

    ::v-deep {
      .v-navigation-drawer__border {
        width: 0;
      }
    }
  }

  .tabs-section {
    margin-bottom: 20px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.71em;
      line-height: 1.3;
      font-weight: bold;
      background-color: transparent;
      flex: 1;
      height: 2.65em;
      border-radius: 5px 5px 0 0;
      outline: none;
      cursor: default;

      &.unblocked {
        cursor: pointer;
      }

      &.active {
        background-color: @color-primary;
        color: #ffffff;
      }
    }
  }

  .button-group-section {
    .label {
      font-size: 2.3em;
      line-height: 1;
    }

    .button-param {
      margin-right: 15px;
    }

    ::v-deep {
      .button-toggle {
        border-radius: 10px !important;
        background-color: #f1f3f6 !important;

        &.v-item--active {
          background-color: @color-primary !important;
          color: #ffffff;

          svg {
            .fill-svg(#ffffff);
          }
        }

        &:before {
          display: none;
        }
      }
    }
  }

  .stepper-content {
    height: 100%;
    padding-left: 10px;
  }

  .order-list-section {
    min-height: 200px;
    height: 100%;
    flex: 1;
    border-bottom: 1px solid #d4d4d4;
    margin-bottom: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .order-list-content {
      position: relative;
      overflow-y: auto;
      z-index: 0;

      .food-counter {
        margin-top: 1.43em;
      }
    }

    .empty-section {
      width: 100%;
      height: 100%;

      span {
        color: #dde1e6;
        font-size: 2.43em;
        line-height: 30px;
        user-select: none;
      }

      svg {
        width: 64px;
        height: 73px;
        margin-bottom: 23px;
      }
    }
  }

  .order-info-section {
    margin-bottom: 27px;

    .label {
      font-size: 1em;
      line-height: 1.5;
      display: block;
      margin-bottom: 6px;
    }

    .order-details {
      margin-bottom: 5px;
      flex-wrap: nowrap;

      .payment-method {
        text-align: center;

        .method-title {
          font-size: 1em;
          line-height: 1.1;
          word-break: break-word;
          margin-top: -3px;
          display: block;
          margin-bottom: 3px;
          .media-xl({
            font-size: 1.14em;
            line-height: 1.125;
          });
        }
      }

      .payment-amount {
        .amount {
          white-space: nowrap;
          font-size: 2.14em; //30px;
          line-height: 1.2;
          margin-top: -7px;
          display: block;
        }
      }

      .person-count {
        .count {
          display: block;
          font-size: 1.78em;
          line-height: 1;
          margin: 0 12px;
        }
      }
    }

    .submit-section {
      .combined-submit-button {
        position: relative;
        z-index: 1;
      }

      .button-submit {
        height: 5.71em !important;
        font-size: 1.07em;
        line-height: 1.4;
        flex: 1;
        border-radius: 0 10px 10px 0 !important;

      }

      .v-btn--disabled {
        color: rgba(#000000, 0.3) !important;
        background-color: rgb(241, 243, 246) !important;
      }
      .button-clocks {
        height: 5.71em !important;
        font-size: 1.07em;
        border-radius: 10px 0 0 10px;
        position: relative;
        z-index: 1;

        &:after {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 1px;
          height: 3.6em;
          background-color: rgba(255, 255, 255, 0.36);
        }

        // белая иконка на сером фоне дизейбла не видна
        &.v-btn--disabled svg path {
          fill: rgba(0, 0, 0, 0.3);
        }

        // смена времени заблокирована: кнопка активна (ховер/клик дают подсказку), но приглушена
        &.button-clocks--locked {
          opacity: 0.97;
        }
      }

    }
  }

  .min-summ-card {
    border-color: @color-error;
    color: @color-error;
  }

  ::v-deep {
    .ps {
      width: 100%;
    }
  }
}
</style>
